import Vue from 'vue';
import SiHaDocumentationListResourceModel from '../../generated/types/model/resource/SiHaDocumentationListResourceModel';

export default class SiHaDocumentationListResourceViewModel extends SiHaDocumentationListResourceModel {
  protected transformToDTO() {}

  protected transformFromDTO() {}

  get siHaDocumentationStatusDisplay() {
    return Vue.$tEnum('page.siHaDocumentationOverview.select.status', this.siHaDocumentationStatus!);
  }

  get isSiHaDocumentationEditable() {
    // Status Abgeschlossen
    return this.siHaDocumentationStatus !== 5;
  }

  get isSiHaDocumentationPrintable() {
    // (Komplett oder Abgeschlossen) && Datum gesetzt
    return (this.siHaDocumentationStatus === 5 || this.siHaDocumentationStatus === 4) && !!this.nextInspectionDueDate;
  }
}
